import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt, faAward } from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/Project.scss';

const projectList = [
  {
    title: "PIXIE — Autonomous Satellite & Rover Mission Management System",
    category: "OpenEnv Hackathon · Meta × HuggingFace",
    tech: ["Python", "FastAPI", "Docker", "Llama 3.1 8B", "GRPO", "React", "TypeScript", "Vercel", "OpenEnv"],
    description: [
      "Built OpenEnv-compliant multi-agent RL environment (Mars 100-Sol + Moon thermal cycle simulators).",
      "GRPO fine-tuned Llama 3.1 8B from −12.4 to +18.5 episodic score, achieving 92% agent survival rate vs 4% baseline.",
      "Engineered modular reward system (science / survival / efficiency / coordination) + multi-satellite collision avoidance engine.",
      "Deployed full production stack: FastAPI backend, Vercel frontend, Docker Hub image, HuggingFace live API."
    ],
    github: "https://github.com/Satyamgupta2365/PIXIE"
  },
  {
    title: "PAISA — AI-Powered Payment Orchestration Platform",
    category: "Pine Labs Hackathon — Winner 🏆",
    tech: ["React 18", "FastAPI", "PostgreSQL", "asyncpg", "AWS Bedrock", "Groq (Llama 3)", "Pine Labs Plural", "Docker"],
    description: [
      "Integrated RBI Account Aggregator framework with LLM pipeline (Groq primary / Bedrock fallback) to analyze bank statements.",
      "Routes payments (UPI/Card/Wallet) dynamically in real-time before checkout.",
      "Designed 5-pillar architecture: Fluid Routing, Cash Flow Predictor, Statement AI, TAP-MCP agentic spending constitution, immutable ledger.",
      "Deployed on AWS us-east-1 with CloudTrail monitoring and achieved sub-200ms routing latency."
    ],
    github: "https://github.com/Satyamgupta2365/PAISA"
  },
  {
    title: "Cryptora — AI Blockchain Wallet Manager",
    category: "Personal Project",
    tech: ["Python", "MCP (Model Context Protocol)", "Blockchain APIs", "LLM Integration"],
    description: [
      "AI-powered multi-chain wallet manager utilizing the Model Context Protocol (MCP).",
      "Provides natural language interface for balance queries, swaps, and audit history.",
      "Improved transaction safety checks and audit compliance by 25%."
    ],
    github: "https://github.com/Satyamgupta2365/Cryptora"
  },
  {
    title: "TensorZero (Contributor)",
    category: "Open Source Contribution",
    tech: ["Rust", "WebAssembly", "LLM Gateway", "Observability"],
    description: [
      "Contributed to the open-source LLMOps platform unifying an LLM gateway, observability, evaluation, optimization, and experimentation.",
      "Helped optimize high-performance gateway components written in Rust."
    ],
    github: "https://github.com/tensorzero/tensorzero"
  },
  {
    title: "Metaflow (Contributor)",
    category: "Open Source Contribution",
    tech: ["Python", "AWS", "Directed Acyclic Graph (DAG) Execution"],
    description: [
      "Contributed to Netflix's framework for building, managing, and deploying production AI/ML systems and data pipelines.",
      "Optimized task scheduling and execution pipeline components in Python."
    ],
    github: "https://github.com/Netflix/metaflow"
  },
  {
    title: "Dify Official Plugins (Contributor)",
    category: "Open Source Contribution",
    tech: ["Python", "LLM Orchestration", "Developer Tools"],
    description: [
      "Contributed official plugins and tool integrations for the LangGenius Dify LLM application orchestration framework.",
      "Designed clean execution hooks for external tool execution within Dify pipelines."
    ],
    github: "https://github.com/Satyamgupta2365/dify-official-plugins"
  }
];

function Project() {
  return (
    <div className="projects-container" id="projects">
      <div className="items-container">
        <h1>Personal & Contributed Projects</h1>
        <div className="projects-grid">
          {projectList.map((project, index) => (
            <div className="project-card" key={index}>
              <div className="project-header">
                <span className="project-category">
                  <FontAwesomeIcon icon={faAward} style={{ marginRight: '6px', color: '#ffd700' }} />
                  {project.category}
                </span>
                <h2>{project.title}</h2>
              </div>
              <div className="project-tech">
                {project.tech.map((t, idx) => (
                  <span className="tech-badge" key={idx}>{t}</span>
                ))}
              </div>
              <ul className="project-description-list">
                {project.description.map((bullet, idx) => (
                  <li key={idx}>{bullet}</li>
                ))}
              </ul>
              <div className="project-footer">
                <a href={project.github} target="_blank" rel="noreferrer" className="github-link">
                  <FontAwesomeIcon icon={faGithub} /> Code Repo <FontAwesomeIcon icon={faExternalLinkAlt} size="xs" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Project;